import { useHistory } from 'react-router-dom'
import Select from 'react-select';
export const EditCrm = () => {

    

    const history = useHistory()


    return (
        <div className="row">
            <div className="col-lg-12">
                <div className="card">
                    <div className="card-body">
                        <form className="control-form">
                            <div className="row">
                                <div className="mb-3 col-6">
                                    <label className="form-label">Customer Name</label>
                                    <input
                                        disabled
                                        className='form-control'
                                    />

                                </div>
                                <div className="mb-3 col-6">
                                    <label className="form-label">Mobile No.</label>
                                    <input
                                        disabled
                                        className='form-control'
                                    />

                                </div>
                            </div>
                            <div className="row">
                                <div className="mb-3 col-6">
                                    <label className="form-label">EMail Address</label>
                                    <input
                                        disabled
                                        className='form-control'
                                    />

                                </div>
                                <div className="mb-3 col-6">
                                    <label className="form-label">Tourist/ Resident</label>
                                    <input
                                        disabled
                                        className='form-control'
                                    />

                                </div>
                            </div>
                            <div className="row">
                                <div className="mb-3 col-6">
                                    <label className="form-label">Inquiry Category</label>
                                    <input
                                        disabled
                                        className='form-control'
                                    />

                                </div>
                                <div className="mb-3 col-6">
                                    <label className="form-label">Inquiry Date</label>
                                    <input
                                        disabled
                                        className='form-control'
                                        type="date"
                                    />

                                </div>
                            </div>
                            <div className="row">
                                <div className="mb-3 col-6">
                                    <label className="form-label">Quotation No</label>
                                    <input
                                        disabled
                                        className='form-control'
                                    />

                                </div>
                                <div className="mb-3 col-6">
                                    <label className="form-label">Customer Service Name</label>
                                    <input
                                        disabled
                                        className='form-control'
                                    />

                                </div>
                            </div>
                            <div className="row">
                                <div className="mb-3 col-6">
                                    <label className="form-label">Retailer Name</label>
                                    <input
                                        disabled
                                        className='form-control'
                                    />

                                </div>
                                <div className="mb-3 col-6">
                                    <label className="form-label">Value of Goods</label>
                                    <input
                                        disabled
                                        className='form-control'
                                    />

                                </div>
                            </div>
                            <div className="row">
                                <div className="mb-3 col-6">
                                    <label className="form-label">Origin</label>
                                    <input
                                        disabled
                                        className='form-control'
                                    />

                                </div>
                                <div className="mb-3 col-6">
                                    <label className="form-label" >Destination</label>
                                    <Select>
                                        <option>Select city</option>
                                        <option>indore</option>
                                        <option>indore</option>
                                        <option>indore</option>
                                        <option>indore</option>
                                        <option>indore</option>

                                    </Select>


                                </div>
                            </div>
                            <div className="row">
                                <div className="mb-3 col-6">
                                    <label className="form-label">Tentative Shipping Date</label>
                                    <input
                                        disabled
                                        className='form-control'
                                    />

                                </div>
                                <div className="mb-3 col-6">
                                    <label className="form-label"> Item Code</label>
                                    <input
                                        disabled
                                        className='form-control'
                                    />

                                </div>
                            </div>
                            <div className="row">
                                <div className="mb-3 col-6">
                                    <label className="form-label"> Promocode</label>
                                    <input
                                        disabled
                                        className='form-control'
                                    />

                                </div>
                                <div className="mb-3 col-6">
                                    <label className="form-label">  Sales Person Name</label>
                                    <input
                                        disabled
                                        className='form-control'

                                    />

                                </div>
                            </div>
                            <div className="mb-3">
                                <label className="form-label" > Cargo Details</label>
                                <Select>
                                    <option>Select city</option>
                                    <option>indore</option>
                                    <option>indore</option>
                                    <option>indore</option>
                                    <option>indore</option>
                                    <option>indore</option>

                                </Select>
                            </div>
                            <div className="mt-3 d-flex justify-content-between">
                                <button
                                    className="btn btn-danger w-sm waves-effect waves-light"
                                    type="button"
                                    onClick={() => history.goBack()}
                                >Back</button>
                                <button className="btn btn-primary w-sm waves-effect waves-light"
                                    type="button"
                                    onClick={() => console.log("fdgfdg")}
                                >Submit</button>
                            </div>
                        </form>
                    </div>

                </div>
            </div>
        </div>
    )
}
